"use client";

import { useServices } from "../services-context";

import { useMemo } from "react";

import { filterServices } from "./helpers";
import {
  isSyntheticPromotionCategoryName,
  withPromotionCategory,
} from "./promotion-category";
import { FIRST_AVAILABLE_PROVIDER_ID } from "@/stores/self-schedule-store";

/** Eligibility is independent of the visitor's search and category choices. */
export function useServiceFilterOptions() {
  const {
    state: {
      data,
      patientType,
      locationType,
      selectedLocation,
      selectedLocationId,
      selectedProviderId,
      selectedCategory,
    },
  } = useServices();
  const locationId = selectedLocation?.id ?? selectedLocationId;
  const providerId =
    selectedProviderId === FIRST_AVAILABLE_PROVIDER_ID
      ? null
      : selectedProviderId;

  const eligibleServices = useMemo(
    () =>
      filterServices(data?.services, {
        searchQuery: "",
        selectedCategory: undefined,
        locations: data?.locations,
        selectedLocationId: locationId,
        selectedProviderId: providerId,
        patientType,
        locationType,
      }),
    [
      data?.services,
      data?.locations,
      locationId,
      providerId,
      patientType,
      locationType,
    ],
  );
  const categories = useMemo(() => {
    const names = new Set(eligibleServices.map((service) => service.category));
    // Pass the full catalog to distinguish a real Promotions category from
    // the synthetic one, even when the real category has no eligible services.
    return withPromotionCategory(data?.categories, eligibleServices).filter(
      (category) =>
        names.has(category.name) ||
        isSyntheticPromotionCategoryName(category.name, data?.categories),
    );
  }, [data?.categories, eligibleServices]);
  const effectiveSelectedCategory =
    !selectedCategory ||
    selectedCategory === "all" ||
    !data ||
    categories.some((category) => category.name === selectedCategory)
      ? selectedCategory
      : undefined;

  return { eligibleServices, categories, effectiveSelectedCategory };
}
